import {
  CLINIC_SEARCH, CLINIC_SEARCH_SUCCESS, CLINIC_SEARCH_FAILURE, CLINIC_SEARCH_AUTOCOMPLETE_SUCCESS,
  CLINICS_CLEAR, CLINIC_CLEAR, CLINIC_AUTOCOMPLETE_CLEAR,
  CLINIC_SAVE, CLINIC_IMAGE_SAVE, CLINIC_SAVE_FAILURE, CLINIC_SAVE_SUCCESS,
  CLINIC_EDIT, CLINIC_EDIT_SUCCESS, CLINIC_EDIT_FAILURE,
  CLINIC_UPLOAD_START,
  CLINIC_DUPLICATE_CHECK, CLINIC_DUPLICATE_CHECK_SUCCESS, CLINIC_DUPLICATE_CHECK_FAILURE,
  CLINIC_SHOW, CLINIC_SHOW_FAILURE, CLINIC_SHOW_SUCCESS,
  CLINIC_DELETE, CLINIC_DELETE_FAILURE, CLINIC_DELETE_SUCCESS,
  CLINIC_STOP, CLINIC_STOP_FAILURE, CLINIC_STOP_SUCCESS,
  CLINIC_SEND_MEDINFO, CLINIC_SEND_MEDINFO_FAILURE, CLINIC_SEND_MEDINFO_SUCCESS,
  CLINIC_DETAIL_PRINT_NOTIFY_PDF, CLINIC_DETAIL_PRINT_NOTIFY_PDF_FAILURE, CLINIC_DETAIL_PRINT_NOTIFY_PDF_SUCCESS,
  CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE, CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE, CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS,
  CLINIC_SHOP_LIST_SAVE, CLINIC_SEARCH_BY_SHOP, CLINIC_SEARCH_BY_SHOP_SUCCESS, CLINIC_SEARCH_BY_SHOP_FAILURE,
  CLINIC_SEARCH_CLINIC_CODE, CLINIC_SEARCH_CLINIC_CODE_SUCCESS, CLINIC_SEARCH_CLINIC_CODE_FAILURE, CLEAR_CLINIC_CODE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    clinic: null,
    clinics: null,
    clinicHistories: null,
    clinicsAutocomplete: null,
    clinicsCurrentPage: null,
    clinicsNextPage: null,
    clinicsPrevPage: null,
    clinicsTotalCount: 0,
    searchParams: null,
    clinicNotify: null,
    clinicImages: [],
    shopList: [],
    searchClinicsByShop: null,
    clinicCodeList: []
  },
  getters: {
    clinic: state => {
      return state.clinic
    },
    clinics: state => {
      return state.clinics
    },
    clinicHistories: state => {
      return state.clinicHistories
    },
    clinicsAutocomplete: state => {
      return state.clinicsAutocomplete
    },
    clinicsCurrentPage: state => {
      return state.clinicsCurrentPage
    },
    clinicsNextPage: state => {
      return state.clinicsNextPage
    },
    clinicsPrevPage: state => {
      return state.clinicsPrevPage
    },
    clinicsTotalCount: state => {
      return state.clinicsTotalCount
    },
    clinicsSearchParams: state => {
      return state.searchParams
    },
    clinicNotify: state => {
      return state.clinicNotify
    },
    clinicImages: state => {
      return state.clinicImages
    },
    searchClinicsByShop: state => {
      return state.searchClinicsByShop
    },
    searchClinicsShopList: state => {
      return state.shopList
    },
    clinicCodeList: state => {
      return state.clinicCodeList
    }
  },
  actions: {
    [CLINIC_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/clinics'
      var data = {}
      var loadparams = true
      var noneList = null
      var callback = () => {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if (params.clear) {
          state.clinics = null
          state.clinicsAutocomplete = null
          state.clinicsCurrentPage = null
          state.clinicsNextPage = null
          state.clinicsPrevPage = null
          state.clinicsTotalCount = 0
        }
        state.searchParams = params.data
        data = params.data
        if (params.autocomplete) {
          loadparams = false
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('noneList' in params) {
          noneList = params.noneList
        }
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CLINIC_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            if (params.autocomplete) {
              commit(CLINIC_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, noneList: noneList, params: params, callback: callback})
            } else {
              commit(CLINIC_SEARCH_SUCCESS, {data: res.data, params: params, callback: callback})
            }
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLINIC_SEARCH_BY_SHOP] ({dispatch, state, commit}, params) {
      var url = '/clinics/search_by_shops'
      var data = {}
      var callback = () => {}
      if (params) {
        state.searchParams = params.data
        data = params.data
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CLINIC_SEARCH_BY_SHOP_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(CLINIC_SEARCH_BY_SHOP_SUCCESS, {data: res.data, params: params, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLINICS_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CLINICS_CLEAR)
      }, sleep)
    },
    [CLINIC_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CLINIC_CLEAR)
      }, sleep)
    },
    [CLINIC_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CLINIC_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },
    [CLINIC_SHOW] ({dispatch, state, commit}, params) {
      var url = '/clinics/' + params.clinicId
      var data = {}
      var callback = () => {}
      if (params) {
        data = params.data
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_SHOW_FAILURE, {data: res.data, callback: callback})
            } else {
              commit(CLINIC_SHOW_SUCCESS, {data: res.data, callback: callback})
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_EDIT] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var url = '/clinics/' + params.clinicHistoryId + '/edit'
        var data = {}
        var callback = () => {}
        if (params) {
          data = params.data
          if ('callback' in params) {
            callback = params.callback
          }
        }
        dispatch('apiGet', {url: url, data: data})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(CLINIC_EDIT_FAILURE, {data: res.data, callback: callback})
                reject()
              } else {
                commit(CLINIC_EDIT_SUCCESS, {data: res.data, callback: callback})
                resolve(res.data)
              }
            }
          })
          .catch(error => {
            throw error
          })
      })
    },
    [CLINIC_DELETE] ({dispatch, state, commit}, params) {
      dispatch('apiDelete', {url: '/clinics/' + params.historyId})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_DELETE_FAILURE, res.data)
            } else {
              commit(CLINIC_DELETE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_STOP] ({dispatch, state, commit}, params) {
      var url = '/clinics/set_enable'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_STOP_FAILURE, res.data)
            } else {
              commit(CLINIC_STOP_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_SEND_MEDINFO] ({dispatch, state, commit}, params) {
      var url = '/clinics/send_medinfo'
      var data = {}
      if (params) {
        data = params.data
        if (!(data.send_type & constant.send_type.fax || data.send_type & constant.send_type.email)) {
          state.clinicNotify = {
            danger: true,
            message_i18n: 'messages.send_medinfo.mail_fax_none_setting'
          }
          setTimeout(() => {
            state.clinicNotify = null
          }, constant.notifyShowTime.normal)
          return
        }
      }
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_SEND_MEDINFO_FAILURE, res.data)
            } else {
              commit(CLINIC_SEND_MEDINFO_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** ログインID・パスワード通知PDF印刷 */
    [CLINIC_DETAIL_PRINT_NOTIFY_PDF] ({dispatch, state, commit}, params) {
      var url = '/clinics/print_notify'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_DETAIL_PRINT_NOTIFY_PDF_FAILURE, res.data)
            } else {
              commit(CLINIC_DETAIL_PRINT_NOTIFY_PDF_SUCCESS, {
                data: res.data,
                callback: params.callback,
                win: params.win
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** ログインID・パスワード通知PDF印刷削除 */
    [CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE] ({dispatch, state, commit}, params) {
      var url = '/clinics/print_notify_delete'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: false})
        .then(res => {
          if (res.data.error) {
            commit(CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE, res.data)
          } else {
            commit(CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS, {
              data: res.data
            })
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_DUPLICATE_CHECK] ({dispatch, state, commit}, params) {
      var url = '/clinics/duplicate_check'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_DUPLICATE_CHECK_FAILURE, res.data)
            } else {
              commit(CLINIC_DUPLICATE_CHECK_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_SAVE] ({dispatch, state, commit}, params) {
      var url = '/clinics/save'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_SAVE_FAILURE, res.data)
            } else {
              commit(CLINIC_SAVE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_IMAGE_SAVE] ({dispatch, state, commit}, params) {
      var url = '/clinics/image_save'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CLINIC_SAVE_FAILURE, res.data)
            } else {
              commit(CLINIC_SAVE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CLINIC_UPLOAD_START] ({state}) {
      state.uploader.status = null
      state.uploader.errors = []
    },
    [CLINIC_SHOP_LIST_SAVE] ({state, commit}, params) {
      commit(CLINIC_SHOP_LIST_SAVE, params)
    },
    [CLINIC_SEARCH_CLINIC_CODE] ({dispatch, state, commit}, params) {
      var data = params.data
      dispatch('apiGet', {url: '/clinics/search_clinic_code', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CLINIC_SEARCH_CLINIC_CODE_FAILURE, res.data)
          } else {
            commit(CLINIC_SEARCH_CLINIC_CODE_SUCCESS, { data: res.data })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_CLINIC_CODE] ({state}) {
      state.clinicCodeList = []
    }
  },
  mutations: {
    [CLINIC_SEARCH_FAILURE] (state, data) {
      console.log('CLINIC_SEARCH_FAILURE')
      if (data.callback) {
        data.callback(null)
      }
    },
    [CLINIC_SEARCH_SUCCESS] (state, {data, params}) {
      console.log('CLINIC_SEARCH_SUCCESS')
      var reSearch = false

      var sendFailsMerge = function (rows, meta) {
        if (meta && !('send-fails' in meta)) {
          return rows
        }
        var result = []
        var sendFails = meta['send-fails']
        rows.forEach(function (row) {
          for (var i = 0; i < sendFails.length; i++) {
            if (parseInt(row['id'], 10) === parseInt(sendFails[i]['clinic-id'], 10)) {
              row.attributes['send-fails'] = sendFails[i]['send-fails']
              break
            }
          }
          result.push(row)
        })
        return result
      }

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.clinics = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.clinicsNextPage = null
        }
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.clinics = state.clinics.concat(data.data)
          state.clinicsCurrentPage = data.meta['current-page']
        } else {
          state.clinics = data.data
          state.clinicsCurrentPage = 1
        }
        if (data.links && data.links['next']) {
          state.clinicsNextPage = data.links['next']
        } else {
          state.clinicsNextPage = null
        }
      }

      // 送信失敗件数
      state.clinics = sendFailsMerge(state.clinics, data.meta)

      // 検索件数
      state.clinicsTotalCount = 0
      if (data.meta && data.meta['total-count']) {
        state.clinicsTotalCount = data.meta['total-count']
      }

      // 先頭に全項目を追加
      if (params.all && params.clinic_all !== null) {
        state.clinics.unshift({'id': params.clinic_all['id'], 'attributes': {'clinic-name': params.clinic_all['name']}})
      }

      if (params.callback) {
        params.callback()
      }
    },
    [CLINICS_CLEAR] (state) {
      state.clinics = null
    },
    [CLINIC_CLEAR] (state) {
      state.clinic = null
      state.clinicHistories = null
    },
    [CLINIC_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('CLINIC_SEARCH_AUTOCOMPLETE_SUCCESS')
      var data = param.data.data
      state.clinicsAutocomplete = data
      // なし追加
      if (param.noneList !== null) {
        if (state.clinicsAutocomplete === null) {
          state.clinicsAutocomplete = []
        }
        state.clinicsAutocomplete.unshift({
          'id': param.noneList['id'],
          'type': 'clinics',
          'attributes': {
            'clinic-name': param.noneList['name'],
            'clinic-name-furigana': '',
            'send-type': '',
            'send-type-post': '',
            'send-type-fax': '',
            'send-type-email': '',
            'send-timing': '',
            'send-timing-hour': '',
            'fax': '',
            'email': '',
            'fusezi-flag': ''
          }
        })
      }

      // 先頭に全項目を追加
      var params = param.params
      if (params.all && params.clinic_all !== null) {
        state.clinicsAutocomplete.unshift({'id': params.clinic_all['id'], 'attributes': {'clinic-name': params.clinic_all['name']}})
      }
    },
    [CLINIC_AUTOCOMPLETE_CLEAR] (state) {
      state.clinicsAutocomplete = null
    },
    [CLINIC_SHOW_FAILURE] (state, data) {
      console.log('CLINIC_SHOW_FAILURE')
      // state.clinicNotify = {
      //   danger: true,
      //   message_direct: data.error
      // }
      // setTimeout(() => {
      //   state.clinicNotify = null
      // }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    [CLINIC_SHOW_SUCCESS] (state, params) {
      console.log('CLINIC_SHOW_SUCCESS')
      state.clinic = params.data.clinic
      state.clinicHistories = params.data.clinic_history.data
      state.clinicImages = params.data.images
      if (params.callback) {
        params.callback(state.clinicHistories)
      }
    },
    [CLINIC_DELETE_FAILURE] (state, data) {
      console.log('CLINIC_DELETE_FAILURE')
      state.clinicNotify = {
        danger: true,
        message_direct: data.error
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CLINIC_DELETE_SUCCESS] (state, params) {
      console.log('CLINIC_DELETE_SUCCESS')
      state.clinicNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
      if (params.callback !== null) {
        params.callback()
      }
    },
    [CLINIC_STOP_FAILURE] (state, data) {
      console.log('CLINIC_STOP_FAILURE')
      state.clinicNotify = {
        danger: true,
        message_direct: data.error
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CLINIC_STOP_SUCCESS] (state, params) {
      console.log('CLINIC_STOP_SUCCESS')
      state.clinic = params.data.clinic
      state.clinicHistories = params.data.clinic_history.data
      var message = ''
      if (params.data.enable_flag === 0) {
        message = 'messages.save.clinic_stop_success'
      } else {
        message = 'messages.save.clinic_restart_success'
      }
      params.callback()
      state.clinicNotify = {
        success: true,
        message_i18n: message
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CLINIC_SEND_MEDINFO_FAILURE] (state, data) {
      console.log('CLINIC_SEND_MEDINFO_FAILURE')
      state.clinicNotify = {
        danger: true,
        message_direct: data.error
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CLINIC_SEND_MEDINFO_SUCCESS] (state, params) {
      console.log('CLINIC_SEND_MEDINFO_SUCCESS')
      state.clinicNotify = {
        success: true,
        message_i18n: 'messages.send_medinfo.success'
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
      if (params.callback !== null) {
        params.callback(params.data)
      }
    },
    /** ログインID・パスワード通知PDF印刷 失敗 */
    [CLINIC_DETAIL_PRINT_NOTIFY_PDF_FAILURE] (state, data) {
      console.log('CLINIC_DETAIL_PRINT_NOTIFY_PDF_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.print.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** ログインID・パスワード通知PDF印刷 成功 */
    [CLINIC_DETAIL_PRINT_NOTIFY_PDF_SUCCESS] (state, params) {
      console.log('CLINIC_DETAIL_PRINT_NOTIFY_PDF_SUCCESS')
      if (params.callback !== null) {
        params.callback(params.data, params.win)
      }
    },
    /** ログインID・パスワード通知印刷削除失敗 */
    [CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE] (state, params) {
      console.log('CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE')
    },
    /** ログインID・パスワード通知印刷削除成功 */
    [CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS] (state, data) {
      console.log('CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS')
    },
    [CLINIC_EDIT_FAILURE] (state, data) {
      // console.log('CLINIC_EDIT_FAILURE')
      // state.clinicNotify = {
      //   danger: true,
      //   message_direct: data.error
      // }
      // setTimeout(() => {
      //   state.clinicNotify = null
      // }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    [CLINIC_EDIT_SUCCESS] (state, data) {
      console.log('CLINIC_EDIT_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [CLINIC_SAVE_FAILURE] (state, data) {
      console.log('CLINIC_SAVE_FAILURE')
      state.clinicNotify = {
        danger: true,
        message_direct: data.error
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
    },
    [CLINIC_SAVE_SUCCESS] (state, data) {
      console.log('CLINIC_SAVE_SUCCESS')
      state.clinicNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.clinicNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [CLINIC_DUPLICATE_CHECK_FAILURE] (state, data) {
      console.log('CLINIC_DUPLICATE_CHECK_FAILURE')
    },
    [CLINIC_DUPLICATE_CHECK_SUCCESS] (state, data) {
      console.log('CLINIC_DUPLICATE_CHECK_SUCCESS')
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [CLINIC_SEARCH_BY_SHOP_FAILURE] (state, data) {
      console.log('CLINIC_SEARCH_BY_SHOP_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [CLINIC_SEARCH_BY_SHOP_SUCCESS] (state, {data, params}) {
      console.log('CLINIC_SEARCH_BY_SHOP_SUCCESS')
      if (params.callback) {
        state.searchClinicsByShop = data.data
        params.callback(data)
      }
    },
    [CLINIC_SHOP_LIST_SAVE] (state, params) {
      console.log('CLINIC_SHOP_LIST_SAVE')
      state.shopList = params
    },
    [CLINIC_SEARCH_CLINIC_CODE_FAILURE] (state, data) {
      console.log('CLINIC_SERARCH_CLINIC_CODE_FAILURE')
    },
    [CLINIC_SEARCH_CLINIC_CODE_SUCCESS] (state, data) {
      console.log('CLINIC_SEARCH_CLINIC_CODE_SUCCESS')
      state.clinicCodeList = data.data.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/clinic.js